
import ConsultaReclamacionesModel from "@/models/ConsultaReclamaciones/ConsultaReclamacionesModel";
import UmbracoApiService from "@/services/UmbracoApiService";
import { Component, Vue } from "vue-property-decorator";
import ConsultaReclamacionesForm from "@/components/Consulta_Reclamaciones/ConsultaReclamacionesForm.vue";
import ConsultaReclamacionesResult from "@/components/Consulta_Reclamaciones/ConsultaReclamacionesResult.vue";
import UserComplaintQuery from "@/models/ConsultaReclamaciones/UserComplaintQuery";
import WsdlService from "@/services/WsdlService";
import ComplaintResponse from "@/models/ConsultaReclamaciones/ComplaintResponse";
import { AxiosResponse } from "axios";
import Swal from "sweetalert2";
import GlobalConfig from "@/GlobalConfig";


@Component({
	components: {
		ConsultaReclamacionesForm,
		ConsultaReclamacionesResult
		}
})
export default class ConsultaReclamaciones extends Vue {
    public umbracoService = new UmbracoApiService();
	public wsdlService: WsdlService = new WsdlService();
	public isConsulting: boolean = true;
	public complaints: Array<ComplaintResponse> = [];
	public isLoading: boolean = false;
	public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;

    public labelData = new ConsultaReclamacionesModel();

    async mounted() {
        await this.getAllData();
    }

    async getAllData() {
        this.labelData =
            await this.umbracoService.getConsultaReclamaciones();
    }
	public async processComplaint(complaintQuery: UserComplaintQuery){
		if(complaintQuery.fromDate && complaintQuery.toDate)
		{
			this.isLoading = true;
			this.wsdlService.GetReclamaciones(complaintQuery).then((response: AxiosResponse<Array<ComplaintResponse>>) => {
				this.complaints = response.data;
				this.isConsulting = false;
				this.isLoading = false;
			}).catch(ex =>
			{
				Swal.fire({
					text: '¡Lo sentimos! Ha ocurrido un error en la consulta',
					icon: "error",
					showConfirmButton: true,
					confirmButtonText: "Ok",
				});
			}).finally(() =>{this.isLoading = false;});
		}
		else{
			Swal.fire({
					text: 'Debe seleccionar una fecha de inicio y una fecha final para consultar',
					icon: "error",
					showConfirmButton: true,
					confirmButtonText: "Ok",
				});
		}
	}
}
